import { render, staticRenderFns } from "./Formality.vue?vue&type=template&id=9db466b0&scoped=true"
import script from "./Formality.vue?vue&type=script&lang=js"
export * from "./Formality.vue?vue&type=script&lang=js"
import style0 from "./Formality.vue?vue&type=style&index=0&id=9db466b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db466b0",
  null
  
)

export default component.exports